// extracted by css-extract-rspack-plugin
export default {"regexInputContainer":"DefinitionRegexEditor-module__regexInputContainer__tY06eUO","testRegexButton":"DefinitionRegexEditor-module__testRegexButton__xHPVABw"};